import admin from "./imageIcons/admin.svg";
import application from "./imageIcons/application-icon.svg";
import arrowDown from "./imageIcons/arrowDown.svg";
import backArrowNew from "./imageIcons/backArrowNew.svg";
import blackInfo from "./imageIcons/infoBlack.svg";
import buttonDown from "./imageIcons/buttonDown.svg";
import close from "./imageIcons/close.svg";
import dashboard from "./imageIcons/dashboard.svg";
import email from "./imageIcons/email.svg";
import filter from "./imageIcons/filter.svg";
import gptw from "./imageIcons/gptw.png";
import group from "./imageIcons/group.svg";
import hamburger from "./imageIcons/hamburger.svg";
import leftCircleArrow from "./imageIcons/circle-arrow-left.svg";
import logo from "./imageIcons/logo.svg";
import nameIcon from "./imageIcons/nameIcon.svg";
import notification from "./imageIcons/notification.svg";
import password from "./imageIcons/password.svg";
import phone from "./imageIcons/phone.svg";
import rightCircleArrow from "./imageIcons/circle-arrow-right.svg";
import search from "./imageIcons/search.svg";
import sortby from "./imageIcons/sortby.svg";
import stickDownArrow from "./imageIcons/stickDownArrow.svg";
import stickUpArrow from "./imageIcons/stickUpArrow.svg";
import user from "./imageIcons/user.svg";
import loader from "./imageIcons/loader.gif";
import eyeIcon from "./imageIcons/eye-solid.svg";
import download from "./imageIcons/download-solid.svg";
import username from './imageIcons/username.svg';
import document from './imageIcons/document.svg';
import partner from './imageIcons/partner.png';
import map from './imageIcons/map.svg';
import editBtn from './imageIcons/edit-button.svg';
import esignBtn from './imageIcons/esign.png';
import eMudraBtn from './imageIcons/emudra.jpeg';
import paymentLog from './imageIcons/Payment.png';


const Images = {
  admin: admin,
  application,
  arrowDown,
  backArrowNew,
  blackInfo,
  buttonDown,
  close,
  dashboard,
  email,
  filter,
  gptw,
  group,
  hamburger: hamburger,
  leftCircleArrow,
  logo: logo,
  nameIcon,
  notification: notification,
  password,
  phone,
  rightCircleArrow,
  search,
  sortby,
  stickDownArrow,
  stickUpArrow,
  user,
  loader,
  eyeIcon,
  download,
  username,
  document,
  partner,
  map,
  editBtn,
  esignBtn,
  eMudraBtn,
  paymentLog
};

export default Images;
